// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-bdtjcxFilterByCollege-index-main_right_content-1q0T3","table":"components-tjcx-bdtjcxFilterByCollege-index-table-3ioKc"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/bdtjcxFilterByCollege/index.css
// module id = 317
// module chunks = 0